import InputComponent from './input.component'

export default InputComponent
